const baseConfig = require('./base')
const envConfig = {
  facebookAppId: '1420928411526742',
  filepickerKey: 'AwvIdM5bQqdaBq64pXyIAz',
  intercomKey: 'z8wz6cwz',
  widgetServerUrl: 'https://widget.choicely.com',
  widgetScriptUrl: 'https://cdn.choicely.com',
  apiHost: 'https://api.choicely.com',
  imageRoot: '//media.choicely.com/image/',
  host: 'https://choicely.com',
  appProtocol: 'https',
  firebaseApiKey: 'AIzaSyAxTCZ85jOrvEy0zfdlphL7L7bgt533ack',
  firebaseAuthDomain: 'loventedapp.firebaseapp.com',
  firebaseDatabaseURL: 'https://loventedapp.firebaseio.com',
  firebaseStorageBucket: 'loventedapp.appspot.com',
  firebaseMessagingSenderId: '765704949713',
  stripePublishableKey: 'pk_live_3E7z7xXS0K8sRnraWLV9zgW3',
  authHostUrl: 'https://auth.choicely.com',
  adminHostUrl: 'https://admin.choicely.com'
}
const config = Object.assign({}, baseConfig, envConfig)

module.exports = config